const urls = {
    //API URLS
    'account': '/api/account/user/',
    'login': '/api/account/login/',
    'logout': '/api/account/logout/',
    'password_reset': '/api/account/password/reset/',
    'password_change': '/api/account/password/change/',
    'edar': '/api/edar/',
    'deployment': '/api/deployment/',

    //Others
    'admin_site': '/admin/',
};

//Allow this to be used as a mixin, so urls are available to the template as well
export default {...urls,
    data: function () { return {
        'urls': urls
    }},
};
